"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSortOptions = exports.defaultVrVideoPreset = exports.defaultAmenityOptions = exports.defaultTypeOptions = exports.defaultBedPresets = exports.defaultSizePresets = exports.defaultBuyPricePreset = exports.defaultRentPricePreset = void 0;
exports.defaultRentPricePreset = [
    { from: 0, to: 25000, name: '< 25K' },
    { from: 25000, to: 40000, name: '25 - 40K' },
    { from: 40000, to: 60000, name: '40 - 60K' },
    { from: 60000, to: 80000, name: '60 - 80K' },
    { from: 80000, to: 100000, name: '80 - 100K' },
    { from: 100000, to: -1, name: '100K+' },
];
exports.defaultBuyPricePreset = [
    { from: 0, to: 8000000, name: '< 8M' },
    { from: 8000000, to: 10000000, name: '8M - 10M' },
    { from: 10000000, to: 15000000, name: '10M - 15M' },
    { from: 15000000, to: 20000000, name: '15M - 20M' },
    { from: 20000000, to: 30000000, name: '20M - 30M' },
    { from: 30000000, to: 50000000, name: '30M - 50M' },
    { from: 50000000, to: 75000000, name: '50M - 75M' },
    { from: 75000000, to: 100000000, name: '75M - 100M' },
    { from: 100000000, to: -1, name: '100M+' },
];
exports.defaultSizePresets = [
    { name: '0 - 600', from: 0, to: 600 },
    { name: '600 - 1000', from: 600, to: 1000 },
    { name: '1,000 - 1,500', from: 1000, to: 1500 },
    { name: '1,500 - 2,000', from: 1500, to: 2000 },
    { name: '2000+', from: 2000, to: -1 },
];
exports.defaultBedPresets = [
    { name: 'Studio', from: 0, to: 0 },
    { name: '1+', from: 1, to: 20 },
    { name: '2+', from: 2, to: 20 },
    { name: '3+', from: 3, to: 20 },
    { name: '4+', from: 4, to: 20 },
    { name: '5+', from: 5, to: 20 },
];
exports.defaultTypeOptions = [
    { name: 'Apartment', value: 1 },
    { name: 'Duplex', value: 2 },
    { name: 'Triplex', value: 3 },
    { name: 'Penthouse', value: 4 },
    { name: 'House', value: 5 },
    { name: 'Studio', value: 7 },
    { name: 'Village House', value: 17 },
];
exports.defaultAmenityOptions = [
    { name: 'Carpark', value: 1 },
    { name: 'Maid\'s Room', value: 2 },
    { name: 'Outdoor Space', value: 3 },
];
exports.defaultVrVideoPreset = [
    { name: 'Virtual Tour', value: 1 },
    { name: 'Video', value: 2 },
];
exports.defaultSortOptions = [
    { name: 'Best Match', value: 0, selected: true },
    { name: 'Price (Low to High)', value: 1 },
    { name: 'Price (High to Low)', value: 2 },
    { name: 'Price per sq.ft. (Low to High)', value: 3 },
    { name: 'Price per sq.ft. (High to Low)', value: 4 },
    { name: 'Size (Large to Small)', value: 5 },
    { name: 'Size (Small to Large)', value: 6 },
    { name: 'District Name (A-Z)', value: 7 },
    { name: 'District Name (Z-A)', value: 8 },
    { name: 'Building Name (A-Z)', value: 9 },
    { name: 'Building Name (Z-A)', value: 10 },
    { name: 'Last Updated', value: 11 },
];
